const PlanSkeleton = ({ count = 3 }) => {
  return Array.from({ length: count }).map((_, n) => (
    <div className="col-lg-3 col-md-6 col-xs-12" key={n}>
      <div className="skeleton-card">
        <div className="skeleton-line skeleton-title" />
        <div className="skeleton-dots">
          <span /><span /><span /><span /><span /><span />
        </div>
        <div className="skeleton-line skeleton-price" />
        <div className="skeleton-line skeleton-sub" />
        <div className="skeleton-limit-row">
          <div className="skeleton-line skeleton-label" />
          <div className="skeleton-line skeleton-badge" />
        </div>
        <div className="skeleton-limit-row">
          <div className="skeleton-line skeleton-label" />
          <div className="skeleton-line skeleton-badge" />
        </div>
        <div className="skeleton-line skeleton-desc mt-3" />
        <div className="skeleton-line skeleton-desc" />
        <div className="skeleton-line skeleton-btn mt-4" />
      </div>
    </div>
  ));
};

export default PlanSkeleton;
